import { DropdownMenuItem } from '@savvy-kit/components/dropdown-menu';

import type { DropdownMenuItemProps } from '@savvy-kit/components/dropdown-menu';
import type { TrackedClickableElementName } from '@savvy/deprecated-shared/tracking/tracked-clickable-element-name';
import { useParentElementViewContext } from '@savvy/deprecated-shared/tracking/parent-element-view-context';
import { useTrackEvent } from '@savvy/deprecated-shared/tracking/use-track-event';

export type TrackedDropdownMenuItemProps = {
  readonly elementName: TrackedClickableElementName;
} & DropdownMenuItemProps;

function TrackedDropdownMenuItem({ elementName, onClick, ...props }: TrackedDropdownMenuItemProps) {
  const trackButtonClick = useTrackEvent('userInteraction');
  const parentElementViewContext = useParentElementViewContext();
  const parentElementName = parentElementViewContext?.parentElementName;
  const parentElementType = parentElementViewContext?.parentElementType;

  return (
    <DropdownMenuItem
      {...props}
      onClick={(event) => {
        trackButtonClick({
          elementName,
          htmlElement: 'button',
          interactionType: 'button_click',
          parentElementName,
          parentElementType,
        });
        return onClick?.(event);
      }}
    />
  );
}

export default TrackedDropdownMenuItem;
